<template>
  <div class="enfooter_pot">
    <div class="footer_up">
      <el-row>
        <el-col :span="5">&nbsp;</el-col>
        <el-col :span="18">
          <h3>Contact Us</h3>
          <ul>
            <li v-for="(element,index) in contactArr" :key="index">
              <img :src="element.icon" alt="">
              <span>{{element.item}}</span>
            </li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div class="footer_down">
      <div>
        <el-link href="#home" type="primary" :underline="false">Copyright©2018 Luoyang Research Institute for Intelligent Agricultural Equipment Co., Ltd. All rights reserved. </el-link>
      </div>
      <div class="footer_space">
        <el-link :href="right.IPNo" target="_blank" type="primary" :underline="false">豫ICP备 19000234号</el-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contactArr: [
        {
          icon: '../../../../static/img/footer/phone.png',
          item: '0379-60199639'
        },
        {
          icon: '../../../../static/img/footer/mail2.png',
          item: '471934'
        },
        {
          icon: '../../../../static/img/footer/mail.png',
          item: 'lychiaic@chiaic.com'
        },
        {
          icon: '../../../../static/img/footer/location.png',
          item:
            'No.21 Science and Technology Avenue,Yibin District, Luoyang, China'
        }
      ],
      right: {
        IPNo: 'http://www.beian.miit.gov.cn',
        sale: 'http://xsfw.chiaic.com',
        law: ''
      },
      police: {
        name: '豫公网安备 41031102000192 号',
        url: '../../../../static/img/footer/police.png',
        link:
          'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41031102000192'
      },
      isCodePlay: false,
      android: '../../../../static/img/footer/android.png'
    };
  },
  watch: {
    // isCodePlay(val) {
    //   console.log('是否开启深度监听');
    //   window.addEventListener('click', () => {
    //   });
    // }
  },
  methods: {
    goPrivacy() {
      this.$router.push({ name: 'privacy' });
    },
    seePT(ptObj) {
      this.isCodePlay = true;
    },
    hideAndroid() {
      this.isCodePlay = false;
    }
  }
};
</script>
<style lang="stylus" scoped>
.enfooter_pot {
  min-height: 320px;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 5;

  ul {
    list-style-type: none;
    margin-left: -40px;
  }

  li {
    margin-top: 10px;
  }

  img {
    vertical-align: middle;
  }

  .footer_up {
    width: 100%;
    background-image: url('../../../../static/img/syscom/bkg-foot.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% auto;
    color: #fff;
    padding: 20px 0;

    .footer_pt {
      text-align: center;
      margin-top: 25%;
      width: 80%;

      .code_img:hover {
        cursor: pointer;
      }
    }

    .pingtai_text {
      margin-top: 10px;
      font-size: 12px;
      color: #fff;
    }

    .friends {
      color: #fff;
    }
  }

  .footer_down {
    text-align: center;
    background-color: #fff;
    height: 80px;
    padding-top: 20px;

    .copy_right {
      color: #409EFF;
      font-size: 14px;
    }
  }

  .show_codeImg {
    position: absolute;
    bottom: 38%;
    right: 14%;
  }
}

.footer_space {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/footer/footer.vue